export const FETCH_ORDER_BOOK_FAILURE = 'FETCH_ORDER_BOOK_FAILURE  ';
export const FETCH_ORDER_BOOK_REQUEST = 'FETCH_ORDER_BOOK_REQUEST  ';
export const FETCH_ORDER_BOOK_SUCCESS = 'FETCH_ORDER_BOOK_SUCCESS ';
